<script>
  export let width = 20;
  export let height = 20;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {width}
  {height}
  viewBox="0 0 20 20"
  fill="currentColor"
  class={$$props.class}>
  <g fill-rule="evenodd">
    <path
      d="M6.57 6.5v7.15a.58.58 0 00.84.53l7.17-3.58a.58.58 0 000-1.05L7.4
      5.97a.58.58 0 00-.84.52z" />
    <path
      d="M10 0a10 10 0 110 20 10 10 0 010-20zm0 1.02a8.98 8.98 0 100 17.96 8.98
      8.98 0 000-17.96z" />
  </g>
</svg>
